import { FC, memo, useEffect, useState } from 'react'
import microApp from '@micro-zoe/micro-app'
import { Menu, SubMenu, MenuItem } from 'mk-pc'
import { genNavTree, IAppItem, INavItem, useAppNavigate } from '@mkmp/core'
import { useAppStore } from '@/stores'
import './index.scss'

interface INavState {
  title: string
  active: string
  openKeys: Array<string>
  selectedKeys: Array<string>
  menus: Array<INavItem>
}

/**
 * 生成菜单树
 * @param menus
 * @returns
 */
const genMenu = (menus: Array<INavItem>) => {
  if (!Array.isArray(menus) || menus.length <= 0) {
    return null
  }

  return menus.map((menu) => {
    if (Array.isArray(menu.children) && menu.children.length > 0) {
      return (
        <SubMenu key={menu.id} icon={menu.icon} title={menu.name}>
          {genMenu(menu.children)}
        </SubMenu>
      )
    } else {
      if (!menu.path) {
        return null
      }
      return (
        <MenuItem key={menu.id} icon={menu.icon}>
          {menu.name}
        </MenuItem>
      )
    }
  })
}

/**
 * 内容页导航
 */
export const LayoutMenu: FC = memo(() => {
  // const { title, active, openKeys, selectedKeys, menus, onSelect, onOpenChange } = props
  const navigate = useAppNavigate()
  const { activePaths } = useAppStore()
  const [current, setCurrent] = useState<INavState>({
    title: '',
    active: '',
    openKeys: [],
    selectedKeys: [],
    menus: []
  })

  // 返回全局数据
  const { org = {} } = (microApp.getGlobalData() || {}) as any
  const { navs = [], apps = [] } = org

  useEffect(() => {
    const pathArray: Array<string> = activePaths?.split(',')
    const idArray: Array<string> = activePaths?.split(',')
    const nav = parseNav(activePaths)
    if (!nav) {
      return setCurrent({
        title: '',
        active: '',
        openKeys: [],
        selectedKeys: [],
        menus: []
      })
    }

    setCurrent({
      title: nav.name,
      active: idArray.pop() || '',
      openKeys: pathArray,
      selectedKeys: [idArray.pop() || ''],
      menus: genNavTree(navs, nav.id, 0)
    })
  }, [activePaths])

  /**
   * 解析路由
   * @param paths
   * @returns
   */
  const parseNav = (paths: string) => {
    if (!paths) return

    const pathArray: Array<string> = paths.split(',')

    // 获取最后一级侧边导航
    const getAsideNav = (navId: string) => {
      const nav = navs.find((n: any) => n.id === navId)
      if (!nav || nav.type === 0) {
        return getAsideNav(pathArray.pop() as string)
      }

      return nav
    }

    return getAsideNav(pathArray.pop() as string)
  }

  /**
   * 菜单选择
   * @param e
   */
  const handleSelect = ({ key }: any) => {
    if (!key) return
    const nav = navs.find((n: INavItem) => n.id === key)
    if (!nav) return

    const app = apps.find((a: IAppItem) => a.id === nav.appId)

    navigate(nav.path, {
      appName: app ? app.code : '',
      appBaseRoute: app ? app.baseRoute : '',
      mainApp: app ? !!app.mainApp : false
    })
  }

  /**
   * 菜单展开
   * @param e
   */
  const handleOpenChange = (e: any) => {
    setCurrent({ ...current, openKeys: e })
  }

  return (
    <section className="layout-menu" style={{ width: current.menus.length > 0 ? 218 : 0, display: current.menus.length > 0 ? 'block' : 'none' }}>
      <div className="layout-menu__content">
        {current.title && <header>{current.title}</header>}
        <Menu
          openKeys={current.openKeys}
          selectedKeys={current.selectedKeys}
          activeKey={current.active}
          onSelect={handleSelect}
          onOpenChange={handleOpenChange}
        >
          {genMenu(current.menus)}
        </Menu>
      </div>
    </section>
  )
})
